import MenuItem from 'components/MenuItem';
import messages from 'containers/AMCDashboard/messages';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { translate } from 'helpers/intl';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import PAGES from 'routes/pages';
import { StoreContext } from 'utils/contextStore';

const ActionButtons = (props: {
  intl: IntlShape;
  setDetailsPageBreadcrumbsPath: Function;
  openModalCreateFolder: Function;
  closeModalCreateFolder: Function;
}) => {
  const { organismeListState } = React.useContext(StoreContext);
  const getOrganismeList = organismeListState?.organismeList;

  const [items, setItems] = React.useState<any[]>([]);

  const hasDM = getOrganismeList?.length > 0;

  useEffect(() => {
    const createDMItem = {
      title: translate({ ...messages.submitHealthRequest }, props),
      icon: 'Order',
      path: PAGES.AMC_DETAILS,
      openModalServices: true,
    };

    const refundsItems = {
      title: translate({ ...messages.claims }, props),
      icon: 'claimsAMC',
      path: PAGES.AMC_DETAILS,
      BreadcrumbsPath: [
        {
          name: 'amc',
          route: PAGES.AMC_DASHBOARD,
        },
        {
          name: 'mesRemboursements',
        },
      ],
    };

    const adhesionItem = {
      title: translate({ ...messages.contractsAndGuarantees }, props),
      icon: 'contractsAndGuaranteesAMC',
      path: PAGES.AMC_DETAILS,
      BreadcrumbsPath: [
        {
          name: 'amc',
          route: PAGES.AMC_DASHBOARD,
        },
        {
          name: 'adhesion',
        },
      ],
    };

    const inayaItem = {
      title: translate({ ...messages.aideSoignant }, props),
      isNew: true,
      icon: 'careGiver',
      onPress: /* istanbul ignore next */ () => {
        GATracking.event(
          EVENT_CATEGORIES.CARE_GIVEN,
          EVENT_ACTION.CLICK,
          'Trouver un aide-soignant',
        );
        window.open('https://inaya.ma/');
      },
    };

    if (hasDM) {
      /* istanbul ignore next */
      setItems([createDMItem, refundsItems, inayaItem]);
    } else {
      setItems([refundsItems, adhesionItem, inayaItem]);
    }
  }, [getOrganismeList, props.intl.locale]);

  return (
    <React.Fragment>
      <MenuItem
        openServices={
          /* istanbul ignore next */ () => {
            props.openModalCreateFolder(true);
          }
        }
        items={items}
        {...props}
      />
    </React.Fragment>
  );
};

export default injectIntl(ActionButtons);
